import { render } from "./content-logs-view-new.vue?vue&type=template&id=6b011d02&scoped=true"
import script from "./content-logs-view-new.vue?vue&type=script&lang=ts"
export * from "./content-logs-view-new.vue?vue&type=script&lang=ts"

import "./content-logs-view-new.vue?vue&type=style&index=0&id=6b011d02&lang=less"
import "./content-logs-view-new.vue?vue&type=style&index=1&id=6b011d02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b011d02"

export default script